// extracted by mini-css-extract-plugin
export default {"dlsView":"dlsView_e8c74","dlsBackgroundBanner":"dlsBackgroundBanner_eefcc","dlsContainer":"dlsContainer_d853c"};